import * as api from '../../../clients/incidents';

import {Action} from '@ngrx/store';

export const GET_INCIDENT_VORLAGE_DETAIL_ADMIN = '[IncidentsModul] GetIncidentVorlageDetailAdmin laden';
export const GET_INCIDENT_VORLAGE_DETAIL_ADMIN_AUSFUEHREN = '[IncidentsModul] GetIncidentVorlageDetailAdmin ausführen';
export const GET_INCIDENT_VORLAGE_DETAIL_ADMIN_ERFOLGREICH = '[IncidentsModul] GetIncidentVorlageDetailAdmin laden erfolgreich';
export const GET_INCIDENT_VORLAGE_DETAIL_ADMIN_FEHLER = '[IncidentsModul] GetIncidentVorlageDetailAdmin Ladefehler';
export const GET_INCIDENT_VORLAGE_DETAIL_ADMIN_NICHT_AUSGEFUEHRT = '[IncidentsModul] GetIncidentVorlageDetailAdmin nicht ausgeführt (evtl. Offline)';


export class GetIncidentVorlageDetailAdminAction implements Action {
    readonly type = GET_INCIDENT_VORLAGE_DETAIL_ADMIN;
        constructor( public id:string , public optPayload: any = null) {}
    }
export class GetIncidentVorlageDetailAdminAusfuehrenAction implements Action {
    readonly type = GET_INCIDENT_VORLAGE_DETAIL_ADMIN_AUSFUEHREN;
        constructor( public id:string , public optPayload: any = null) {}
    }
export class GetIncidentVorlageDetailAdminErfolgreichAction implements Action {
    readonly type = GET_INCIDENT_VORLAGE_DETAIL_ADMIN_ERFOLGREICH;
        constructor(public payload: api.IncidentVorlageDetail,  public id:string , public optPayload: any = null) {}
    }
export class GetIncidentVorlageDetailAdminFehlerAction implements Action {
    readonly type = GET_INCIDENT_VORLAGE_DETAIL_ADMIN_FEHLER;
        constructor(public payload: any,  public id:string , public optPayload: any = null) {}
    }
export class GetIncidentVorlageDetailAdminNichtAusgefuehrtAction implements Action {
    readonly type = GET_INCIDENT_VORLAGE_DETAIL_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type IncidentsQueryIncidentVorlageDetailAdminActions =
    GetIncidentVorlageDetailAdminAction
    | GetIncidentVorlageDetailAdminAusfuehrenAction
    | GetIncidentVorlageDetailAdminErfolgreichAction
    | GetIncidentVorlageDetailAdminFehlerAction
    | GetIncidentVorlageDetailAdminNichtAusgefuehrtAction
    ;
